import {Image, Product, Variant} from "../../models/product";
import styles from "./style.module.scss";
import {Component, h} from "preact";
import {productService} from "../../services/product-service";
import ProductImageWithOverlay from "../product-image-with-overlay";
import {connect} from "redux-zero/preact";
import actions from "../../store/actions";
import {NY_Tracker, TrackingEvent} from "../../services/tracking-service";
import {i18nService} from "../../services/i18n-service";
import {navigationService} from "../../services/navigation-service";
import {ImageResolution} from "../product-image";
import {Like} from "../../models/customer";
import {FilterMap} from "../../models/filter";
import {ProductPrice} from "../product-price";

interface Props {
  product: Product;
  desktopColumnCount: number;
  resolution?: ImageResolution;
  clickCallback?: (variant?) => void
  dimension: string;
  scrollContainer?: string;
  likes: Like[];
  filters: FilterMap;
  forceCutout?: boolean;

  setScrollPosition(pos: number);

}

const mapToProps = ({product, desktopColumnCount, likes, filters}) =>
  ({product, desktopColumnCount, likes, filters});

class ProductItem extends Component<Props, any> {

  shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<any>, nextContext: Readonly<any>): boolean {
    if (this.props.likes !== nextProps.likes) {
      return true;
    }
  }

  // noinspection JSMethodCanBeStatic
  showDetail(variant: Variant) {
    let event = {
      label: `${this.props.product.web_category} - ${variant.productId}`,
      action: 'selectProduct',
      category: 'Products',
      isSale: variant.sale ? '1' : '0',
      imageType: (variant.images.find(i => i.position === 0) as Image)?.type
    };
    NY_Tracker.trackClick(event as TrackingEvent);
    navigationService.showDetailView(variant.productId, variant.id);
  }

  handleClick(e: MouseEvent, variant: Variant) {
    e.preventDefault();
    this.getBase().href = null;
    if (this.props.clickCallback) {
      this.props.clickCallback(variant);
    } else {
      this.showDetail(variant)
    }
  }

  getBase() {
    return this.base as HTMLAnchorElement;
  }

  isEditorialSelected() {
    if (this.props.filters) {
      return !!this.props.filters.editorials.find((pf) => pf.selected);
    }
  }

  render() {
    if (!(this.props.product)) {
      return null;
    }
    const product = this.props.product;
    const variant = this.props.product.getMatchingVariant();
    return (
      <a href={navigationService.getDetailViewLink(variant.productId, variant.id)}
         class={styles['product-item-container']}
         onClick={(e) => this.handleClick(e, variant)}
         title={i18nService.translate(productService.getTranslationKey(product))}
      >
        <ProductImageWithOverlay scrollContainer={this.props.scrollContainer} product={product}
                                 variant={variant} resolution={this.props.resolution}
                                 dimension={this.props.dimension} forceCutout={this.props.forceCutout}
                                 desktopColumnCount={this.props.desktopColumnCount}/>
        <div class={`${styles['info']} ${this.props.dimension === 'MatchingProducts' ? styles['matching-products'] : ''}
            ${this.props.dimension === 'List'
          ? (() => {
            switch (this.props.desktopColumnCount) {
              case 5:
                return styles['columns-5'];
              case 3:
                return styles['columns-3'];
              default:
                return '';
            }
          })()
          : ''} ${this.isEditorialSelected() ? styles.editorial : ''}`}>
          <div class={styles.description}>{i18nService.translate(productService.getTranslationKey(product))}</div>
          <ProductPrice variant={variant} styles={styles} />
          <div
            class={`${product.hasAdditionalColors() ? styles['additional-colors'] : styles['hide-container']} ${!variant.showPriceLabel() ? styles['margin-bottom'] : ''}`}>
            {product.hasAdditionalColors() ?
              product.getAdditionalColorsCount() > 1 ?
                `+${product.getAdditionalColorsCount()} ${i18nService.translate('product_additional_colors')}`
                : `+${product.getAdditionalColorsCount()} ${i18nService.translate('product_additional_color')}`
              : '\u00A0'}
          </div>
        </div>
      </a>
    );
  }
}

export default connect(mapToProps, actions)(ProductItem)
